import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { LEFT_ARROW, RIGHT_ARROW } from 'src/sb-tools/typescript/constants/keycodes';
import { PrintService } from '../../services/print.service';
import { AttachmentService } from 'src/sb-tools/typescript/services/attachment.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { AttachmentType } from '@sb-tools/typescript/enums/attachment-type.enum';
import { FileViewComponent } from '@sb-document-viewer/components/file-view/file-view.component';
import { InlineSVGComponent } from '../../../Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserAvatarComponent } from '../../../Frontend-User-Avatar-Module/user-avatar.component';
import { DatePipe, NgClass } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'sb-document-viewer-modal',
    templateUrl: './document-viewer-modal.component.html',
    styleUrls: ['./document-viewer-modal.component.scss'],
    imports: [
        forwardRef(() => FileViewComponent),
        InlineSVGComponent,
        TranslateModule,
        ModalModule,
        UserAvatarComponent,
        DatePipe,
        NgClass,
        TooltipModule,
    ],
})
export class DocumentViewerModalComponent implements OnInit, OnDestroy {
    attachments;
    currentAttachment;
    event;
    fileIndex: number;
    isFilePreviewInMessage: boolean;
    isForwardAllowed = false;
    isForwarding = false;
    isCarouselEnabled = false;
    modalId?: string;
    onForwardFile: (file) => void;
    permalink?: string;
    reply;

    private unsubscriber = new Subject<void>();

    constructor(
        public printService: PrintService,
        private attachmentService: AttachmentService,
        private modalRef: BsModalRef,
        private modalService: BsModalService,
    ) {}

    ngOnInit(): void {
        this.isCarouselEnabled = this.attachments && this.attachments.length > 1;
        this.currentAttachment = this.attachments[this.fileIndex];
        this.currentAttachment.isDownloadAvailable = this.attachmentService.isDownloadFileAvailable(
            this.currentAttachment.url,
        );

        if (this.isCarouselEnabled) {
            this.handleKeyDownClick = this.handleKeyDownClick.bind(this);
            document.addEventListener('keydown', this.handleKeyDownClick);
        }

        this.attachmentService.isForwardingFileFinished.pipe(takeUntil(this.unsubscriber)).subscribe((isFinished) => {
            this.isForwarding = !isFinished;
        });
    }

    decline(): void {
        if (this.modalId) {
            this.modalService.hide(this.modalId);
        } else {
            this.modalRef.hide();
        }
    }

    forwardFile(): void {
        this.attachmentService.changeForwardingStatus(false);
        this.onForwardFile(this.currentAttachment);
    }

    onModalBodyClick(): void {
        if (this.currentAttachment.attachmentType === AttachmentType.image) {
            this.decline();
        }
    }

    toggleFileView(n: number): void {
        if (n > 0 && this.fileIndex === this.attachments.length - 1) {
            return;
        } else if (n < 0 && this.fileIndex === 0) {
            return;
        }

        this.fileIndex += n;

        if (this.fileIndex >= this.attachments.length) {
            this.fileIndex = 0;
        } else if (this.fileIndex < 0) {
            this.fileIndex = this.attachments.length - 1;
        }

        this.currentAttachment = this.attachments[this.fileIndex];

        this.currentAttachment.isDownloadAvailable = this.attachmentService.isDownloadFileAvailable(
            this.currentAttachment.url,
        );
    }

    private handleKeyDownClick(e): void {
        if (this.isForwarding) {
            return;
        }

        if (e.keyCode === RIGHT_ARROW) {
            this.toggleFileView(1);
        } else if (e.keyCode === LEFT_ARROW) {
            this.toggleFileView(-1);
        }
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();

        if (this.isCarouselEnabled) {
            document.removeEventListener('keydown', this.handleKeyDownClick);
        }
    }
}
